<script>
  import {onMount} from 'svelte';
  import { validateAtInput } from './Form/utils.js';
  import { sgettext } from '../i18n.js';

  export let value = '';
  export let id = '';
  export let key = '';
  export let label = '';
  export let placeholder = '';
  export let required = false;
  export let isValid = true;
  export let errors = '';
  export let schema = null;
  export let floatClass = '';
  export let additionalClass = '';
  export let hidden = false;
  export let min = '';
  export let max = '';
  export let object = {};
  export let help = '';
  export let inline = false;
  export let style;
  export let focus = false;

  let touched = false;

  if(!key){
      key = id;
  }

  async function handleOnBlur(event){
    try {
      if( schema && schema.fields.hasOwnProperty(key)) {
        await validateAtInput(schema, key, object);
        isValid = true;
        errors = '';
      }
    } catch(err) {
      isValid = false;
      errors = err.message;
    }
  }

  onMount(() => {
    // Wait for mount and focus this element on mount if focus=true
    if (focus) {
      document.getElementById(id).focus()
    }         
  })

  const classes = [
    'form-control',
    'text-input',
    ...(!isValid ? ['invalid'] : []),
    ...(hidden ? ['hidden'] : []),
    ...(inline ? ['inline'] : []),
    ...(additionalClass ? [additionalClass] : [])
  ].join(' ');

</script>

{#if label}
	<label for={id} title={required ? sgettext('$$FIELD_REQUIRED$$') : ''}
		>{label}</label
	>
{/if}

<input
	draggable={true}
	on:dragstart={(ev) => ev.preventDefault()}
	type="number"
	{min}
	{max}
	autocomplete="off"
	{id}
	{placeholder}
	class={classes}
	bind:value
	on:change
	on:input
	on:focus={() => (touched = true)}
	on:blur={handleOnBlur}
	{style}
/>

{#if help}
	<small class="form-text text-muted">{help}</small>
{/if}
{#if !isValid}
	<div class="errors">{errors}</div>
{/if}

<style>
	.errors {
		color: #dc3545;
		font-size: 13px;
	}

	.text-input {
		height: 44px;
	}

	.invalid {
		border-color: #dc3545;
	}
	.inline {
		display: inline-block;
	}

</style>
